import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.palette.grayscale100};
  ${({ theme }) => theme.typography('$title_03')};
`;

export const LeftPanel = styled.div`
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0 12px;
`;

export const ButtonMemo = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 88px;
`;

export const ButtonAddSchedule = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 88px;
  background-color: ${({ theme }) => theme.palette.brand400};
`;

export const ButtonSelectPeriodic = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 4px;
  border-radius: 80px;
  padding: 4px 8px;
  white-space: pre;
  background-color: ${({ theme }) => theme.palette.bg500};
  color: ${({ theme }) => theme.palette.grayscale300};
  ${({ theme }) => theme.typography('$body_02')};
`;

export const WeekPerfiodicIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33325 13.3337V2.66699H4.88325V13.3337H1.33325ZM6.23325 13.3337V2.66699H9.78325V13.3337H6.23325ZM11.1166 13.3337V2.66699H14.6666V13.3337H11.1166Z"
        fill="#BCB8C4"
      />
    </svg>
  );
};

export const DayPerfiodicIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14.5V13.1667H14V14.5H2ZM2 11.8333V5.16667H14V11.8333H2ZM2 3.83333V2.5H14V3.83333H2Z"
        fill="#BCB8C4"
      />
    </svg>
  );
};
